<template>
  <!--基础存放容器-->
  <div class="swiper-container">
    <!-- 需要进行轮播的部分 -->
    <div class="swiper-wrapper">
      <!-- 每个节点 -->
      <!-- <a
        v-for="item in swiperList"
        :key="item.id"
        class="swiper-slide"
        :href="returnUrl(item.type, item.id)"
        target="_blank"
        ><div class="E_recruit_box_list_flex_li">
          <div class="E_recruit_box_list_flex_li_img">
            <div class="E_recruit_box_list_flex_li__img_label">{{item.type | rightTypeHotFn()}}</div>
            <img
              class="editTarget"
              :src="item.img_link.length == 0?'https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/defult.png':item.img_link"
            />
          </div>
          <div class="E_recruit_box_list_flex_li_body">
            <div class="E_recruit_box_topBox">
              <p class="E_recruit_box_list_flex_li_body_title">
                {{item.name}}
              </p>
              <div class="E_recruit_box_list_flex_li_body_time">
                <p class="E_recruit_box_list_flex_li_body_time_p">
                  文件大小：2.53MB
                </p>
              </div>
              <div class="E_recruit_box_list_flex_li_body_teacher">
                <div class="E_recruit_box_list_flex_li_body_teacher_left">
                  <span>更新时间：</span>
                  <span class="E_recruit_teacher">2019-04-10</span>
                </div>
                <div
                  class="E_recruit_box_list_flex_li_body_teacher_right"
                ></div>
              </div>
            </div>
            <div class="E_recruit_box_list_flex_li_body_bottom">
              <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">
                <span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span"
                  >免费</span
                >
              </p>

              <div class="E_recruit_box_list_flex_li_body_teacher_right">
                <span class="E_recruit_box_list_flex_li_body_teacher_right_num"
                  >0人</span
                >
                <span>已学</span>
              </div>
            </div>
          </div>
        </div>
      </a> -->

      <!-- <a
        class="swiper-slide"
        href="/activity/specialtraining/#/Detail/apply/61"
        target="_blank"
        data-swiper-slide-index="5"
        style="width: 270px"
        ><div class="E_recruit_box_list_flex_li">
          <div class="E_recruit_box_list_flex_li_img">
            <div class="E_recruit_box_list_flex_li__img_label">打卡</div>
            <img
              class="editTarget"
              src="https://fview.5kjs.com/activity/21sign/camp/2022/04/db928478e8119632a8997fedaeb28fbd.jpg"
            />
          </div>

          <div class="E_recruit_box_list_flex_li_body">
            <div class="E_recruit_box_topBox">
              <p class="E_recruit_box_list_flex_li_body_title">
                第二期·21天语文教招打卡训练
              </p>
              <div class="E_recruit_box_list_flex_li_body_time">
                <p class="E_recruit_box_list_flex_li_body_time_p">学期：21天</p>
              </div>
              <div class="E_recruit_box_list_flex_li_body_teacher">
                <div class="E_recruit_box_list_flex_li_body_teacher_left">
                  <span>开营时间：</span>
                  <span class="E_recruit_teacher">2022-04-19</span>
                </div>
                <div
                  class="E_recruit_box_list_flex_li_body_teacher_right"
                ></div>
              </div>
            </div>
            <div class="E_recruit_box_list_flex_li_body_bottom">
              <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">
                ￥<span
                  class="E_recruit_box_list_flex_li_body_bottom_p_jge_span"
                  >99.00</span
                >
              </p>

              <div class="E_recruit_box_list_flex_li_body_teacher_right">
                <span class="E_recruit_box_list_flex_li_body_teacher_right_num"
                  >0人</span
                >
                <span>已付款</span>
              </div>
            </div>
          </div>
        </div>
      </a> -->
    </div>
    <!--如果需要使用分页器-->
    <div class="swiper-pagination swiper-pagination-white"></div>
  </div>
</template>

<script>
import swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      swiperList: null,
    };
  },
  methods: {
    // 获取热门推荐数据
    // 为了节省时间不得已用JS的方式渲染数据，修改内容之后方便直接复制使用
    getSwiper() {
      let origin = window.location.origin;
      origin =
        origin == "http://localhost:8080" ? "http://hnjszp.xueba.hk" : origin;
      this.$axios
        .get(`${origin}/course_right`, {})
        .then((res) => {
          this.swiperList = res;
          // 延迟等数据渲染之后初始化轮播图

          let html = ``;
          res.forEach((item) => {
            // 上方公用部分
            // 如果是课程中心则需要加上外部盒子
            if (item.link && item.link != null) {
              html += `<a href='${item.link}' target="_blank">`;
            } else {
              if (item.type == "camp") {
                html += `<a class="swiper-slide " href='/activity/specialtraining/#/Detail/apply/${item.id}' target="_blank">`;
              } else {
                if (item.type == "class" && item.type_id == 7) {
                  html += `<a class="swiper-slide " href='/productdetail/live/${item.id}' target="_blank">`;
                } else {
                  html += `<a class="swiper-slide " href='/productdetail/${item.type}/${item.id}' target="_blank">`;
                }
              }
            }

            html += `<div class="E_recruit_box_list_flex_li">
                            <div class="E_recruit_box_list_flex_li_img">
                                <div class="E_recruit_box_list_flex_li__img_label">
                                ${
                                  item.top_label != null &&
                                  item.top_label.length != 0
                                    ? item.top_label.name
                                    : this.rightTypeHotFn(item)
                                }
                                </div>
                                ${
                                  item.type == "camp" &&
                                  item.opening_time != null
                                    ? `<div class="camp_time_box">${this.campTime(
                                        item.opening_time
                                      )}</div>`
                                    : ""
                                }
                                <img class="editTarget"
                                    src="${
                                      item.type == "library"
                                        ? item.img_link
                                          ? item.img_link
                                          : "https://fview.5kjs.com/wap_img/newShool/product/newshoolcommon/library.png"
                                        : item.img_link
                                        ? item.img_link
                                        : "https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/defult.png"
                                    }">
                            </div>

                            <div class="E_recruit_box_list_flex_li_body">
                                <div class="E_recruit_box_topBox">
                                    <p class="E_recruit_box_list_flex_li_body_title">${
                                      item.name
                                    }</p>
                                   <div class="E_recruit_box_list_flex_li_body_coupon">
                                   ${
                                     item.lower_label != null &&
                                     item.lower_label.length != 0
                                       ? `<span class="E_recruit_box_list_flex_li_body_coupon_red">${item.lower_label.name}</span>`
                                       : ""
                                   }
                                   <!-- <p class="E_recruit_box_list_flex_li_body_coupon_p">119元券可用</p>
                                        <span class="E_recruit_box_list_flex_li_body_coupon_red">组合套餐</span> -->
                                    </div>
                                `;
            // html += `<div class="E_recruit_box_list_flex_li_center">`

            switch (item.type) {
              case "live":
                if (item.channeltype == 1) {
                  html += `<div class="E_recruit_box_list_flex_li_body_time">
                                                            <i class="iconfont icon-shijian"></i>
                                                            <p class="E_recruit_box_list_flex_li_body_time_p">已结束</p>
                                                        </div>`;
                } else if (item.end_time < this.time()) {
                  html += `  <div class="E_recruit_box_list_flex_li_body_time">
                                                            <i class="iconfont icon-shijian"></i>
                                                            <p class="E_recruit_box_list_flex_li_body_time_p">已结束</p>
                                                        </div>`;
                } else if (item.is_end > 0 && item.isPurchase > 0) {
                  html += `<div class="E_recruit_box_list_flex_li_body_time">
                                                            <span class="E_liveIng"><span class="E_live_ico"></span> 正在直播</span>
                                                        </div>   `;
                } else {
                  html += ` <div class="E_recruit_box_list_flex_li_body_time">
                                                            <i class="iconfont icon-shijian"></i>
                                                            <p class="E_recruit_box_list_flex_li_body_time_p">时间：${item.live_time}</p>
                                                        </div>`;
                }

                html += ` <div class="E_recruit_box_list_flex_li_body_teacher">
                                                        <div class="E_recruit_box_list_flex_li_body_teacher_left">
                                                            <span>主讲：</span>
                                                            <span class="E_recruit_teacher">`;
                item.teacher.forEach((item) => {
                  html += `${item.name}`;
                });

                html += ` </span>
                                        </div>
                                            <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                            <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${item.make_num}人</span>`;

                if (item.channeltype == 1) {
                  html += ` <span>预约</span>`;
                } else if (item.end_time < this.time()) {
                  html += `  <span>看过</span>`;
                } else if (item.is_end > 0 && item.isPurchase > 0) {
                  html += ` <span>在看</span>`;
                } else if (item.isPurchase > 0) {
                  html += ` <span>预约</span>`;
                } else {
                  html += ` <span>预约</span>`;
                }

                html += `
                                        </div>
                                                    </div>
                                                </div>

                                                <div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                      item.sale_price == 0
                                                        ? `<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>`
                                                        : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                    }
                                                    </p>
                            `;

                if (item.living == 2 && item.channeltype == 1) {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom_button E_isSubscribe shangchuanzhogn">
                                                            <span class="editTargetTxT">回放上传中</span>
                                                        </div>`;
                } else if (item.living == 2 && item.channeltype == 2) {
                  html += ` <div class="E_recruit_box_list_flex_li_body_bottom_button E_kapian_border">
                                                            <span class="editTargetTxT">看回放</span>
                                                        </div>`;
                } else if (item.living == 1) {
                  html += ` <div class="E_recruit_box_list_flex_li_body_bottom_button">
                                                            <span class="editTargetTxT">进入</span>
                                                        </div>`;
                } else if (item.living == 0 && item.Subscribe == true) {
                  html += `  <div class="E_recruit_box_list_flex_li_body_bottom_button E_isSubscribe">
                                                            <span class="editTargetTxT">已预约</span>
                                                        </div>`;
                } else {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom_button">
                                                            <span class="editTargetTxT">预约</span>
                                                        </div>`;
                }
                html += `</div>`;

                break;
              case "class":
                html += `
                                                    <div class="E_recruit_box_list_flex_li_body_time">
                                                        <p class="E_recruit_box_list_flex_li_body_time_p">有效期：${item.validity}</p>
                                                    </div>
                                                </div>`;
                if (item.isPurchase > 0) {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom">
                                                        <p class="E_recruit_box_list_flex_li_body_bottom_p_jge E_isbuy">
                                                            已购买
                                                        </p>
                        
                                                        <div class="E_recruit_box_list_flex_li_body_bottom_button  E_kapian_border">
                                                            <span class="editTargetTxT">去学习</span>
                                                        </div>
                                                    </div>`;
                } else {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom">
                                                        <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                          item.sale_price == 0
                                                            ? `<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>`
                                                            : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                        }
                                                        </p>
                        
                                                        <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                            <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                              item.member_num
                                                            }人</span>
                                                            <span>已付款</span>
                                                        </div>
                                                    </div>`;
                }
                break;
              case "book":
                html += `
                                                <div class="E_recruit_box_list_flex_li_body_time">
                                                    <p class="E_recruit_box_list_flex_li_body_time_p">${
                                                      item.brief == null
                                                        ? ""
                                                        : `${item.brief}`
                                                    }</p>
                                                </div>
                                            </div>
                                            <div class="E_recruit_box_list_flex_li_body_bottom">
                                                <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                  item.sale_price == 0
                                                    ? `<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>`
                                                    : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                } 
                                                </p>
                
                                                <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                    <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                      item.member_num_fictitious
                                                    }人</span>
                                                    <span>已购</span>
                                                </div>
                                            </div>`;

                break;
              case "face":
                html += `
                                                <div class="E_recruit_box_list_flex_li_body_time">
                                                    <p class="E_recruit_box_list_flex_li_body_time_p">${
                                                      item.brief
                                                    }</p>
                                                </div>
                                            </div>
                                            <div class="E_recruit_box_list_flex_li_body_bottom">
                                                <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                  item.sale_price == 0
                                                    ? `<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>`
                                                    : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                }
                                                </p>
                
                                                <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                    <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                      item.member_num
                                                    }人</span>
                                                    <span>付款</span>
                                                </div>
                                            </div>`;

                break;
              case "library":
                html += `
                                                <div class="E_recruit_box_list_flex_li_body_time">
                                                    <p class="E_recruit_box_list_flex_li_body_time_p">文件大小：${(
                                                      item.size /
                                                      (1024 * 1024)
                                                    ).toFixed(2)}MB</p>
                                                </div>
                                                <div class="E_recruit_box_list_flex_li_body_teacher">
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_left">
                                                        <span>更新时间：</span>
                                                        <span class="E_recruit_teacher">${item.last_time.substr(
                                                          0,
                                                          10
                                                        )}</span>
                                                    </div>
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                    </div>
                                                </div>
                                            </div>`;
                if (item.Subscribe) {
                  html += ` <div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge E_isbuy">
                                                        已购买
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_bottom_button  E_kapian_border">
                                                        <span class="editTargetTxT">去下载</span>
                                                    </div>
                                                </div>`;
                } else {
                  html += `
                            <div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                      item.sale_price == 0
                                                        ? '<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>'
                                                        : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                    }
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                        <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                          item.member_num_fictitious
                                                        }人</span>
                                                        <span>已学</span>
                                                    </div>
                                                </div>
                            `;
                }

                break;
              case "combination":
                html += `
                                                <div class="E_recruit_box_list_flex_li_body_time">
                                                    <p class="E_recruit_box_list_flex_li_body_time_p">${item.brief}</p>
                                                </div>
                                            </div>`;

                if (item.isPurchase > 0) {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge E_isbuy">
                                                        已购买
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_bottom_button  E_kapian_border">
                                                        <span class="editTargetTxT">去学习</span>
                                                    </div>
                                                </div>`;
                } else {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                      item.sale_price == 0
                                                        ? '<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>'
                                                        : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.sale_price}</span>`
                                                    }
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                        <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                          item.member_num
                                                        }人</span>
                                                        <span>已付款</span>
                                                    </div>
                                                </div>`;
                }
                break;
              case "camp":
                html += `
                                                <div class="E_recruit_box_list_flex_li_body_time">
                                                    <p class="E_recruit_box_list_flex_li_body_time_p">学期：${item.semester}天</p>
                                                </div>
                                                <div class="E_recruit_box_list_flex_li_body_teacher">
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_left">
                                                        <span>开营时间：</span>
                                                        <span class="E_recruit_teacher">${item.opening_time}</span>
                                                    </div>
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_right">
                
                                                    </div>
                                                </div>
                                            </div>`;
                if (item.isPurchase > 0) {
                  html += `<div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge E_isbuy">
                                                        已购买
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_bottom_button  E_kapian_border">
                                                        <span class="editTargetTxT">去打卡</span>
                                                    </div>
                                                </div>`;
                } else {
                  html += ` <div class="E_recruit_box_list_flex_li_body_bottom">
                                                    <p class="E_recruit_box_list_flex_li_body_bottom_p_jge">${
                                                      item.original_price == 0
                                                        ? `<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">免费</span>`
                                                        : `￥<span class="E_recruit_box_list_flex_li_body_bottom_p_jge_span">${item.original_price}</span>`
                                                    }
                                                    </p>
                    
                                                    <div class="E_recruit_box_list_flex_li_body_teacher_right">
                                                        <span class="E_recruit_box_list_flex_li_body_teacher_right_num">${
                                                          item.member_num_fictitious
                                                        }人</span>
                                                        <span>已付款</span>
                                                    </div>
                                                </div>`;
                }
                break;

              default:
                break;
            }
            html += `         </div>
                        </div>
                    </a>`;
          });

          this.$(".swiper-wrapper").empty().append(html);
          let that = this;
          setTimeout(() => {
            that.initSwiper();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 初始化轮播图
    initSwiper() {
      new swiper(".swiper-container", {
        //设置轮播的循环方式
        loop: true,
        //设置自动播放间隔时间
        autoplay: 3000,
        // 轮播效果,默认为平滑轮播
        effect: "slide",
        //分页器
        pagination: ".swiper-pagination",
        //前进后退按钮
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        // 用户中断轮播后续播
        autoplayDisableOnInteraction: false,
      });
    },
    // 过滤轮播图元素跳转链接
    returnUrl(type, id) {
      let url = ``;
      if (type == "camp") {
        url = `/activity/specialtraining/#/Detail/apply/${id}`;
      } else {
        if (type == "class" && id == 7) {
          url = `/productdetail/live/${id}`;
        } else {
          url = `/productdetail/${type}/${id}`;
        }
      }
      return url;
    },
    // 清洗右侧热门推荐类型数据
    rightTypeHotFn(item) {
      let typeStr = "";
      switch (item.type) {
        case "package":
          typeStr = "套餐";
          break;
        case "live":
          typeStr = "直播";
          break;
        case "camp":
          typeStr = "打卡";
          break;
        case "book":
          typeStr = "图书";
          break;
        case "class":
          typeStr = "课程";
          break;
        case "library":
          if (item.library_type == "download") {
            typeStr = "附件文库";
          } else {
            typeStr = "图文文库";
          }
          break;
        case "face":
          typeStr = "面授";
          break;
        case "combination":
          typeStr = "组合";
          break;
        default:
          break;
      }

      return typeStr;
    },
    // 获取当前时间
    time() {
      return new Date().getTime();
    },
    // 计算特训营卡片时效性函数
    campTime(targetTime) {
      let targettime = new Date(targetTime).getTime();
      let nowTime = new Date().getTime();
      let falg = nowTime - targettime;
      if (falg >= 0) {
        return "已结束";
      } else {
        return "正在报名";
      }
    },
  },
  computed: {},
  filters: {
    // 清洗右侧热门推荐类型数据
    rightTypeHotFn(item) {
      let typeStr = "";
      switch (item.type) {
        case "package":
          typeStr = "套餐";
          break;
        case "live":
          typeStr = "直播";
          break;
        case "camp":
          typeStr = "打卡";
          break;
        case "book":
          typeStr = "图书";
          break;
        case "class":
          typeStr = "课程";
          break;
        case "library":
          if (item.library_type == "download") {
            typeStr = "附件文库";
          } else {
            typeStr = "图文文库";
          }
          break;
        case "face":
          typeStr = "面授";
          break;
        case "combination":
          typeStr = "组合";
          break;
        default:
          break;
      }

      return typeStr;
    },
  },
  mounted() {
    this.getSwiper();
  },
};
</script>

<style lang="less" scoped>
/deep/ .swiper-pagination-white .swiper-pagination-bullet {
  background-color: red;
  width: 0.625rem;
  height: 3px;
  background: #cbcbcb;
  border-radius: 1px;
  opacity: 0.4;
}

/deep/ .swiper-pagination-bullet-active {
  width: 1.375rem !important;
  opacity: 1 !important;
}

.flexStyle(@direction, @item, @justify) {
  display: flex;
  flex-direction: @direction;
  align-items: @item;
  justify-content: @justify;
}

// 课程卡片
/deep/ .E_recruit_box_list_flex_li {
  margin-bottom: 2.5rem;
  cursor: pointer;
  overflow: hidden;
  width: 270px;
  height: 399px;
  background: #ffffff;
  border-radius: 0.3125rem;
  overflow: hidden;

  .flexStyle(column, center, flex-start);

  &:hover {
    .E_recruit_box_list_flex_li_body_title {
      color: #ff7f7f !important;
    }
  }

  .E_recruit_box_list_flex_li_img {
    width: 100%;
    height: 201px;
    position: relative;
    background-color: #f4f8ff;
    .flexStyle(row, center, center);
    img {
      max-width: 100%;
      height: 100%;
    }

    //文字展现标签
    .E_recruit_box_list_flex_li__img_label {
      // width: 3.8rem;
      padding: 0 13px;
      height: 1.4rem;
      background: linear-gradient(13deg, #f22221, #f65537);
      border-radius: 0.3rem 0px 0.6rem 0px;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 0.8rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 1.4rem;

      img {
        width: 11px;
        height: 11px;
      }
    }

    // 打卡右侧标签
    .camp_time_box {
      padding: 0 13px;
      height: 1.4rem;
      background: linear-gradient(13deg, #f22221, #f65537);
      border-radius: 0px 0.3rem 0px 0.6rem;
      position: absolute;
      right: 0;
      top: 0;
      font-size: 0.8rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 1.4rem;
    }

    //图标展现标签
    .E_recruit_box_list_flex_li__img_label_icon {
      padding: 0 0.875rem;
      height: 1.4rem;
      background: linear-gradient(13deg, #f22221, #f65537);
      border-radius: 0.3rem 0px 0.6rem 0px;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 0.8rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 1.4rem;

      .icon-bofang {
        color: #fff;
        font-size: 0.2rem;
      }
    }
  }

  .E_recruit_box_list_flex_li_body {
    width: 100%;
    flex: 1;
    // border: 1px solid #EDEDED;
    border-top: none;
    padding: 1rem;
    position: relative;
    border: 1px solid #ededed;
    border-radius: 0 0 5px 5px;
    .E_recruit_box_topBox {
      width: 100%;
      height: 135px;
      .flexStyle(column, flex-start, flex-start);
    }

    .E_recruit_box_list_flex_li_center {
      height: 53px;
    }

    .E_recruit_box_list_flex_li_body_title {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: #545e64;
      line-height: 17px;
      margin: 0 auto;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      /*设置方向*/
      -webkit-line-clamp: 2;
      /*设置超过为省略号的行数*/
      overflow: hidden;
    }

    //优惠券
    .E_recruit_box_list_flex_li_body_coupon {
      width: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      .E_recruit_box_list_flex_li_body_coupon_p {
        margin-right: 0.3125rem;
        padding: 0 0.1875rem;
        height: 21px;
        background: #fff2e3;
        border-radius: 0.2rem;
        font-size: 0.7rem;
        color: #cd7c2f;
        line-height: 21px;
        text-align: center;
      }

      .E_recruit_box_list_flex_li_body_coupon_red {
        margin-right: 5px;
        text-align: center;
        padding: 0 7px;
        height: 21px;
        background: #fff4f3;
        border-radius: 3px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f96b60;
        line-height: 21px;
      }
    }

    //预约时间
    .E_recruit_box_list_flex_li_body_time {
      width: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin-top: 0.4rem;

      .icon-shijian {
        font-size: 0.9rem;
        color: #9598a2;
        margin-right: 0.2rem;
      }

      .E_recruit_box_list_flex_li_body_time_p {
        font-size: 0.8rem;
        font-weight: 400;
        color: #9598a2;
      }
    }

    // 主讲老师
    .E_recruit_box_list_flex_li_body_teacher {
      margin-top: 0.375rem;
      width: 100%;
      .flexStyle(row, center, space-between);

      .E_recruit_box_list_flex_li_body_teacher_left {
        font-size: 0.75rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9598a2;
      }
    }

    .E_recruit_box_list_flex_li_body_teacher_right {
      .flexStyle(row, center, center);
      font-size: 0.75rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9598a2;

      .E_recruit_box_list_flex_li_body_teacher_right_num {
        color: #f96b60;
      }
    }

    .E_recruit_box_list_flex_li_body_bottom {
      // padding: 0 1.25rem;
      // position: absolute;
      width: 100%;
      // bottom: .9rem;
      // right: 0;
      // left: 0;
      // margin: auto;
      .flexStyle(row, center, space-between);

      // 已购买
      .E_isbuy {
        font-size: 1.125rem !important;
        font-family: Microsoft YaHei;
        font-weight: bold !important;
        color: #f22322;
        line-height: 1.6875rem;
      }

      // 已购买按钮
      .E_isBuy_btn {
        // padding: 0 .9375rem;
        background: #ffffff;
        border: 1px solid #f22322;
        border-radius: 0.8125rem;

        font-size: 0.75rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f22322;
      }

      //课程预约
      .E_recruit_box_list_flex_li_body_bottom_p {
        font-size: 0.8rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9598a2;
        line-height: 1.7rem;

        span {
          font-size: 0.8rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #f22322;
          line-height: 1.5rem;
        }
      }

      //课程购买
      .E_recruit_box_list_flex_li_body_bottom_p_jge {
        font-size: 0.8rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f22322;

        span {
          font-weight: bold;
          font-size: 1.2rem;
        }

        .E_oldprice {
          font-size: 0.75rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          text-decoration: line-through;
          color: #9598a2;
        }
      }

      .E_recruit_box_list_flex_li_body_bottom_button {
        width: 4.6rem;
        // height: 1.5625rem;
        background: linear-gradient(90deg, #f22221, #f65537);
        border-radius: 0.9rem;
        font-size: 0.8rem;
        line-height: 26px;
        text-align: center;
        color: #fff;

        &:hover {
          background: linear-gradient(90deg, #f65537, #f22221);
        }
      }

      .E_kapian_border {
        background: #ffffff;
        border: 1px solid #f22322;
        border-radius: 13px;
        color: #f22322;
        line-height: 24px;

        &:hover {
          border: none;
          background: linear-gradient(90deg, #f22221, #f65537);
          color: #fff;
        }
      }

      .shangchuanzhogn {
        width: 88px;
      }

      // 已预约状态
      .E_isSubscribe {
        background: #dddfe8;
      }
    }
  }
}
</style>